import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

export default function InfoLabel({ label, description }) {
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.35 }}>
      <Typography component="span" variant="body2" sx={{ fontWeight: 800, whiteSpace: 'normal' }}>
        {label}
      </Typography>
      <Tooltip title={description} arrow enterTouchDelay={0}>
        <IconButton size="small" aria-label={`About ${label}`}>
          <InfoOutlinedIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
